module.exports = __webpack_public_path__ + "static/img/fgdxs.630f344.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/microFireHouse/images/prodImgs/fgdxs.jpg
// module id = oklH
// module chunks = 21